import { render, staticRenderFns } from "./EiGoodsDetail.vue?vue&type=template&id=10613794&scoped=true&"
import script from "./EiGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./EiGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./EiGoodsDetail.vue?vue&type=style&index=0&id=10613794&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10613794",
  null
  
)

export default component.exports